"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const _1 = require(".");
const initialProfileInputs = {
    id: 0,
    name: '',
    uid: '',
    thumbnail: '',
    uploadedImg: '',
};
function default_1({ open, closeDialog, activeProfile, }) {
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog });
    const isEdit = activeProfile !== undefined;
    const initialFormValues = isEdit
        ? {
            id: activeProfile.id,
            name: activeProfile.name,
            uid: String(activeProfile.uid),
            thumbnail: activeProfile.thumbnail,
            uploadedImg: '',
        }
        : initialProfileInputs;
    const { t } = (0, react_i18next_1.useTranslation)();
    const profileForm = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
    });
    const resetFormValues = () => {
        profileForm.reset(initialFormValues);
    };
    (0, react_1.useEffect)(() => {
        if (open)
            resetFormValues();
    }, [open, activeProfile]);
    return ((0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: open, PaperProps: {
            sx: {
                alignItems: 'center',
                width: '90%',
                maxWidth: '400px',
                p: '20px 16px 16px',
                borderRadius: '8px',
                m: 0,
                h3: {
                    mb: '10px',
                    lineHeight: '26px',
                    fontSize: '18px',
                    fontWeight: 700,
                },
                h4: {
                    mb: '10px',
                    color: 'rgba(0, 0, 0, 0.7)',
                    lineHeight: '17px',
                    fontSize: '14px',
                },
            },
        } }, { children: [isEdit ? (0, jsx_runtime_1.jsx)("h3", { children: t('프로필 수정') }) : (0, jsx_runtime_1.jsx)("h3", { children: t('새 프로필 만들기') }), !isEdit && (0, jsx_runtime_1.jsx)("h4", { children: t('[마켓,구독,차단]이 하나씩 더 생겨요') }), (0, jsx_runtime_1.jsx)(_1.ProfileThumbnail, { profileForm: profileForm }), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ sx: {
                    rowGap: '10px',
                    width: '100%',
                    p: '6px 0 16px',
                    h6: {
                        mb: '2px',
                        fontSize: '12px',
                        lineHeight: '18px',
                        color: 'rgba(0, 0, 0, 0.9)',
                    },
                    input: {
                        width: '100%',
                        height: '40px',
                        p: '0 14px',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        borderRadius: '4px',
                        lineHeight: '18px',
                        fontSize: '14px',
                        ':focus': {
                            outline: 'none',
                            border: '1px solid black !important',
                        },
                    },
                    h5: {
                        width: '100%',
                        mt: '2px',
                        fontSize: '12px',
                    },
                } }, { children: [(0, jsx_runtime_1.jsx)(_1.ProfileName, { profileForm: profileForm }), (0, jsx_runtime_1.jsx)(_1.ProfileUid, { profileForm: profileForm })] })), (0, jsx_runtime_1.jsx)(_1.ProfileSubmit, { isEdit: isEdit, closeDialog: closeDialog, resetFormValues: resetFormValues, profileForm: profileForm })] })));
}
exports.default = default_1;
